module.exports = __webpack_public_path__ + "static/img/go-m.c3b71ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/go-m.jpg
// module id = 152
// module chunks = 1